import { ReactNode } from "react";
import { useHistory } from "react-router-dom";

import { appConfig } from "@/modules/app/appConfig";

import { ApiContext } from "../contexts/ApiContext";
import { applyAuthRefreshInterceptor } from "../utils/createAxios/applyAuthRefreshInterceptor";
import { createAxios } from "../utils/createAxios/createAxios";
import { createJsonApiClient } from "../utils/createJsonApiClient/createJsonApiClient";

export const ApiProvider = ({ children }: { children: ReactNode }) => {
  const axiosInstance = createAxios(appConfig.api.url);
  const history = useHistory();

  applyAuthRefreshInterceptor(axiosInstance, history);

  const jsonApi = createJsonApiClient(axiosInstance);
  return (
    <ApiContext.Provider value={{ jsonApi }}>{children}</ApiContext.Provider>
  );
};
